(function(){
  var SIZES = ["P","M","G","GG"];
  var w = document.getElementById("mvv-weight");
  var h = document.getElementById("mvv-height");
  var resultBox = document.getElementById("mvv-result-box");
  var badge = document.getElementById("mvv-badge");
  var result = document.getElementById("mvv-result");
  var warning = document.getElementById("mvv-warning");
  var warningText = document.getElementById("mvv-warning-text");
  var levelEls = document.querySelectorAll("#mvv-level-group .mvv-level");
  var selectedLevel = 1;

  levelEls.forEach(function(el){
    el.addEventListener("click", function(){
      selectedLevel = parseInt(el.getAttribute("data-level"));
      levelEls.forEach(function(e){ e.classList.remove("is-active"); e.setAttribute("aria-pressed", "false"); });
      el.classList.add("is-active");
      el.setAttribute("aria-pressed", "true");
      calc();
    });
  });

  function calc(){
    var weight = parseFloat(w.value);
    var height = parseFloat(String(h.value).replace(",", "."));
      if (height && height < 3) height = height * 100;
    if (!weight) { resultBox.style.display = "none"; warning.style.display = "none"; return; }
    var idx;
    if (weight <= 67) idx = 0;
    else if (weight <= 72) idx = 1;
    else if (weight <= 87) idx = 2;
    else idx = 3;

    if (height) {
      if (height >= 188 && idx < 3) idx += 1;
      else if (height <= 160 && idx > 0) idx -= 1;
    }

    var baseIdx = idx;
    if (selectedLevel === 2 && idx > 0) idx -= 1;

    resultBox.style.display = "flex";
    badge.textContent = SIZES[idx];
    result.textContent = SIZES[idx];

    if (SIZES[idx] === "G" || SIZES[idx] === "GG") {
      warning.style.display = "flex";
      var usual = SIZES[idx] === "G" ? "M" : "G";
      warningText.textContent = "Modelagem de compressão menor que o padrão. Se você costuma vestir " + usual + " em outras marcas, esse " + SIZES[idx] + " deve ficar no ponto certo.";
    } else if (idx !== baseIdx) {
      warning.style.display = "flex";
      warningText.textContent = "Compressão firme: escolhemos um tamanho abaixo do padrão pelo seu peso/altura para um ajuste mais justo.";
    } else {
      warning.style.display = "none";
    }
  }

  w.addEventListener("input", calc);
  h.addEventListener("input", calc);
})();
